/**
 * 艺术字动画
 * 2019-4-22
 */
(function (root, factory) {
  if (typeof module === 'object' && typeof module.exports === 'object') {
    // CommonJS
    module.exports = factory(this);
  } else {
    //  全局变量
    factory(root);
  }
})(this, function (root) {
  var data = {};

  var methods =  {
    linear: function (t, b, c, d) {
      return c * (t / d) + b;
    },
    getColorChange: function (color,color1) {
      if(!color) color = '#000';
      var rgb = this._hex2rgb(color),
          rgb1 = this._hex2rgb(color1);
      return [
        ...rgb, ...rgb1, rgb1[0] - rgb[0], rgb1[1] - rgb[1], rgb1[2] - rgb[2]
      ]
    },
    GlitchInitEffect: function (ps, control, color) {
      if (!color) color = ['#0ff', '#f0f']
      control[0] = ps.children().clone().css({
        position: 'absolute',
        top: 0,
        left: 0,
        opacity: .8,
        color: color[0],
        zIndex: -1,
      });
      control[1] = ps.children().clone().css({
        position: 'absolute',
        top: 0,
        left: 0,
        opacity: .8,
        color: color[1],
        zIndex: -2,
      });
      ps.append(control)
    },
    GlitchPlay: function (data, control, frame, frameRate) {
      var transform = {x: 0, y: 0};
      var range = 5 / 100 * data.size / data.editorScale;
      var time = frame / frameRate % .3;
      var eve = .3 * frameRate / 5;
      frame %= eve;
      if(time >= 0 && time < 0.06) {
        transform.x = this.linear(frame, 0, -range, eve)
        transform.y = this.linear(frame, 0, range, eve)
      }else if(time < 0.12) {
        transform.x = -range
        transform.y = this.linear(frame, range, -2 * range, eve)
      }else if(time < 0.18) {
        transform.x = this.linear(frame, -range, 2 * range, eve)
        transform.y = transform.x
      }else if(time < 0.24) {
        transform.x = range
        transform.y = this.linear(frame, range, -2 * range, eve)
      }else if(time <= 0.3) {
        transform.x = this.linear(frame, range, -range, eve)
        transform.y = this.linear(frame, -range, range, eve)
      }
      control[0].css({
          transform: 'translate('+ transform.x +'px,' + transform.y +'px)' + ' scale(' + 1 / data.editorScale + ')'
      })
      control[1].css({
          transform: 'translate('+ -transform.x +'px,' + -transform.y +'px)' + ' scale(' + 1 / data.editorScale + ')'
      })
    },
    GlitchRedInitEffect: function (ps, control) {
      var color = ['rgba(227, 6, 19)', 'rgba(0, 159, 227)']
      this.GlitchInitEffect(ps, control, color)
    },
    GlitchRedPlay: function (data, control, frame, frameRate) {
      this.GlitchPlay(data, control, frame, frameRate)
    },
    GradenInitEffect: function(ps, control) {
      control[0] = ps.children()
    },
    GradenPlay: function (data, control, frame, frameRate) {
      var trans = {x: 0, y: 0};
      var time = frame / frameRate % 1;
      var colorC = this.getColorChange(data.color, '#fff');
      var arr = [];
      frame %= (frameRate / 2);
      if(time >= 0 && time < 0.5) {
        trans.x = this.linear(frame, 60, 120, frameRate / 2)
        trans.y = this.linear(frame, 0, 20, frameRate / 2)
        arr[0] = this.linear(frame, colorC[0], colorC[6], frameRate / 2)
        arr[1] = this.linear(frame, colorC[1], colorC[7], frameRate / 2)
        arr[2] = this.linear(frame, colorC[2], colorC[8], frameRate / 2)
      } else {
        trans.x = this.linear(frame, 200, -120, frameRate / 2)
        trans.y = this.linear(frame, 20, -20, frameRate / 2)
        arr[0] = this.linear(frame, colorC[3], -colorC[6], frameRate / 2)
        arr[1] = this.linear(frame, colorC[4], -colorC[7], frameRate / 2)
        arr[2] = this.linear(frame, colorC[5], -colorC[8], frameRate / 2)
      }

      control[0].css({
        color: this._rgb2hex(arr),
        filter: 'saturate('+trans.x+'%) hue-rotate('+trans.y+'deg) ' + control[1]
      })
    },
    GradenGoldenrodInitEffect: function(ps, control) {
      this.GradenInitEffect(ps, control)
    },
    GradenGoldenrodPlay: function (data, control, frame, frameRate) {
      this. GradenPlay(data, control, frame, frameRate)
    },
    GradenPinkInitEffect: function(ps, control) {
      this.GradenInitEffect(ps, control)
    },
    GradenPinkPlay: function (data, control, frame, frameRate) {
      this. GradenPlay(data, control, frame, frameRate)
    },
    GradenAzureInitEffect: function(ps, control) {
      this.GradenInitEffect(ps, control)
    },
    GradenAzurePlay: function (data, control, frame, frameRate) {
      this. GradenPlay(data, control, frame, frameRate)
    },
    GradenTomatoInitEffect: function(ps, control) {
      this.GradenInitEffect(ps, control)
    },
    GradenTomatoPlay: function (data, control, frame, frameRate) {
      this. GradenPlay(data, control, frame, frameRate)
    },
    GradenYellowInitEffect: function(ps, control) {
      this.GradenInitEffect(ps, control)
    },
    GradenYellowPlay: function (data, control, frame, frameRate) {
      this. GradenPlay(data, control, frame, frameRate)
    },
    GradenLightyellowInitEffect: function(ps, control) {
      this.GradenInitEffect(ps, control)
    },
    GradenLightyellowPlay: function (data, control, frame, frameRate) {
      this. GradenPlay(data, control, frame, frameRate)
    },
    _hex2rgb: function(hex) {
      var arr = [];
      hex = hex.toLowerCase();
      if(hex.length === 4) {
        var shex = '#';
        for(var i=1; i<4; i+=1){
          shex += hex.slice(i,i+1).concat(hex.slice(i,i+1));
        }
        hex = shex;
      }
      for(var i=1; i<7; i+=2) {
        arr.push(parseInt("0x" + hex.slice(i, i+2)));
      }
      return arr
    },
    _rgb2hex: function(arr) {
      return "#" + ((1 << 24) + (arr[0] << 16) + (arr[1] << 8) + arr[2] << 0).toString(16).slice(1);
    },
  }

  function artTextInit (type, ps, control) {
    methods[type + 'InitEffect'] && methods[type + 'InitEffect'](ps, control)
  }
  function artTextPlay (type, data, control, frame, frameRate) {
    methods[type + 'Play'] && methods[type + 'Play'](data, control, frame, frameRate)
  }

  if (root.AnimEditor) {
    root.AnimEditor.artTextInit = artTextInit;
    root.AnimEditor.artTextPlay = artTextPlay;
    return;
  }

  return function(AnimEditor) {
    AnimEditor.artTextInit = artTextInit;
    AnimEditor.artTextPlay = artTextPlay;
  }
})


//////////////////
// WEBPACK FOOTER
// ./static/animengine/js/art-effects/artEffect.js
// module id = g4dH
// module chunks = 16